<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header title="商品咨询" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
            <div v-if="consult_list && consult_list.length">
                <div class="div consult-item"  v-for="(item, index) in consult_list" :key="index">
            		<div class="head">
            			<div class="type">{{consult_type[item.consulttype_id].consulttype_name}}</div>
            			<div class="time">{{ $moment.unix(item.consult_addtime).format('YYYY年MM月DD日') }}</div>
            		</div>
            		<div class="goods_info" @click="goGoods(item.goods_id)">
            			<div class="image-wrapper">
            				<img class="img" :src="item.goods_image"/>
            			</div>
            			<div class="p-info">
            				<div class="goods_name">{{item.goods_name}}</div>
            				<div class="goods_price">${{item.goods_price}}</div>
            			</div>
            		</div>
            		<div class="div consult-info">
            			<div class="consult_content"><span>咨询内容：</span>{{item.consult_content}}</div>
            			<div class="consult_reply" v-if="item.consult_reply"><span>商家回复：</span>{{item.consult_reply}}</div>
            		</div>
            		<div class="ds-button-large div common-btn mb-10" @click="replay(item.consult_id)" v-if="!item.consult_reply">立即回复</div>
                </div>
            </div>
            <empty-record v-else-if="consult_list && !consult_list.length"></empty-record>
        </div>
    </div>
</template>

<script>
import { Toast, Indicator, MessageBox } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
import { getConsultList, replyConsult } from '../../../api/sellerConsult'
export default {
  data () {
    return {
      consult_type: {},
      params: { 'page': 0, 'per_page': 10 },
      consult_list: false,
      loading: false, // 是否加载更多
      isMore: true // 是否有更多
    }
  },
  components: {
    EmptyRecord
  },
  computed: {

  },
  mounted () {
  },
  created () {

  },
  watch: {

  },
  methods: {
    replay (id) {
      MessageBox.prompt('请输入回复', '').then(({ value, action }) => {
        replyConsult(id, value).then(res => {
          Toast(res.message)
          this.params = { 'page': 0, 'per_page': 10 }
          this.consult_list = false
          this.loading = false
          this.isMore = true
          this.loadMore()
        }).catch(function (error) {
          Toast(error.message)
        })
      })
    },
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getConsultList(true)
      }
    },
    getConsultList () {
      Indicator.open()

      getConsultList(this.params).then(res => {
        Indicator.close()
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }

        let temp = res.result.consult_list
        if (temp) {
          if (!this.consult_list) {
            this.consult_list = temp
            this.consult_type = res.result.consult_type
          } else {
            this.consult_list = this.consult_list.concat(temp)
          }
        }
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    }
  }

}
</script>

<style scoped lang="scss">
.consult-item{
	background:#fff;
	border-bottom:1px solid #e1e1e1;
	margin-top: $modelSpace;
	border-radius: .5rem;
	padding: 0 $pageSpace;
	box-sizing: border-box;
	.head{
		padding: .3rem 0;
		display: flex;
		align-items: center;
		.type{
			font-size: .8rem;
			color: #333;
		}
		.time{
			font-size: .6rem;
			color: #999;
			margin-left: auto;
		}
	}
	.goods_info{
		display: flex;
		box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.06);
		.image-wrapper{
			width: 4rem;
			height: 4rem;
			flex: 0 0 4rem;
			border-radius: .5rem;
			overflow: hidden;
			img{
				width: 4rem;
				height: 4rem;
			}
		}
		.p-info{
			margin-left: .5rem;
			.goods_name{
				color: #333;
				font-size: .7rem; 
				line-height: .8rem;
				height: 1.6rem;
				margin-top: .4rem;
				overflow: hidden;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				padding: 0 .3rem;
				box-sizing: border-box;
			}
			.goods_price{
				color: $primaryColor;
				font-size: .8rem;
				margin-top: 1rem;
			}
		}
	}
	.consult-info{
		padding: $modelSpace 0;
		.consult_content{
			font-size: .7rem;
			color: #666;
			text{
				color: #333;
			}
		}
		.consult_reply{
			font-size: .7rem;
			color: #666;
			text{
				color: #333;
			}
		}
	}
	.ds-button-large{
		width: 25%;
		margin: 0 auto;
	}
}
</style>
